import { CheckOutlined } from '@ant-design/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { PageSection } from '../../../../shared/ui/PageSection'
import cls from './PriceSection.module.scss'

const PriceSection: React.FC = () => {
    const { t } = useTranslation()
    const included = t('price.included', { returnObjects: true }) as string[]

    return (
        <PageSection
            title={t('price.title')}
            style={{ backgroundColor: 'var(--bg-base)' }}
        >
            <div className={cls.card}>
                <div className={cls.priceRow}>
                    <span className={cls.currency}>$</span>
                    <span className={cls.amount}>90</span>
                    <span className={cls.period}>/{t('price.perDay')}</span>
                </div>
                <p className={cls.deposit}>{t('price.deposit')}</p>
                <hr className={cls.divider} />
                <ul className={cls.list}>
                    {included.map((item) => (
                        <li key={item} className={cls.listItem}>
                            <span className={cls.listCheck} aria-hidden>
                                <CheckOutlined />
                            </span>
                            {item}
                        </li>
                    ))}
                </ul>
            </div>
        </PageSection>
    )
}

export default PriceSection
